import {
  Action,
  DialogPosition,
  DockType,
  OperationType,
  Position,
  RestApiPrefix,
  WarningType,
  WindowType
} from '../dispatcher/Types';
import { RELOAD_TYPE } from '../components/grid/Types';

export const logError: Action = [{
  data: {
    usePrefix: RestApiPrefix.default,
    url: '/log',
    method: 'post'
  },
  actionType: {
    dispatcherId: 'ErrorTrap'
  },
  handleError: true,
  mappingName: 'errorResponse',
  type: OperationType.request
}];

export const closeDialog: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}];

export const closeWarningDialog: Action = [{
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}];

export const closePreviousDialog: Action = [{
  index: DialogPosition.previous,
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}];

export const closePreviousWarningDialog: Action = [{
  index: DialogPosition.previous,
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}];

export const setFocusToActiveDialog: Action = [{
  data: {
    typeFocus: 'closed'
  },
  type: OperationType.data
}, {
  args: ['typeFocus'],
  name: 'setFocusToActiveDialog',
  moduleName: 'Dialog'
}, {
  args: ['typeFocus'],
  name: 'setFocusToActiveDialog',
  moduleName: 'WarningDialog'
}];

export const versionChanged: Action = [{
  moduleName: 'CookieManager',
  name: 'hasFunctionalCookie'
}, {
  moduleName: 'CookieManager',
  name: 'hasAnalyticsCookie'
}, {
  className: 'sm info',
  items: [{
    operations: [{
      moduleName: 'AuthService',
      name: 'reload'
    }],
    btnName: 'Auth.versionChanged.ok',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      moduleName: 'AuthService',
      name: 'reload'
    }]
  }],
  warningType: WarningType.warning,
  text: 'Auth.versionChanged.text',
  title: 'Auth.versionChanged.title',
  type: OperationType.warning
}];

export const isModuleDisplayedInfo: Action = [{
  moduleName: 'General',
  name: 'isDisplayed',
  mappingName: 'isGeneralDisplayed',
  type: OperationType.addOperationData
}, {
  moduleName: 'TmGroupAdmins',
  name: 'isDisplayed',
  mappingName: 'isTmGroupAdminsDisplayed',
  type: OperationType.addOperationData
}, {
  moduleName: 'TMattributes',
  name: 'isDisplayed',
  mappingName: 'isTMattributesDisplayed',
  type: OperationType.addOperationData
}, {
  moduleName: 'TabPanelFormExamples',
  name: 'setDisplayedInfo',
  args: ['isGeneralDisplayed', 'isTmGroupAdminsDisplayed', 'isTMattributesDisplayed']
}];

export const testInputsWithDisplayedProperty: Action = [{
  moduleName: 'InputsFormForDisplayedProperty',
  name: 'getInputText',
  mappingName: 'text',
  type: OperationType.addOperationData
}, {
  moduleName: 'InputForDisplayedProperty',
  displayed: true,
  name: 'setInputText',
  args: ['text']
}];

export const treeGridRequestMask: Action = [{
  condition: '{mask}',
  all: [{
    evaluate: true,
    moduleName: '{topLevelComponentName}',
    type: OperationType.maskModule
  }],
  self: [{
    evaluate: true,
    moduleName: 'TreeGrid',
    moduleId: '{moduleId}',
    type: OperationType.maskModule
  }],
  type: OperationType.switch
}];

export const treeGridRequestUnMask: Action = [{
  condition: '{mask}',
  all: [{
    evaluate: true,
    moduleName: '{topLevelComponentName}',
    type: OperationType.unmaskModule
  }],
  self: [{
    evaluate: true,
    moduleId: '{moduleId}',
    moduleName: 'TreeGrid',
    type: OperationType.unmaskModule
  }],
  type: OperationType.switch
}];

export const treeGridLoadData: Action = [{
  name: 'treeGridRequestMask',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        treeParams: '{params}',
        treeUrl: '{url}'
      },
      counter: 0,
      finalResponseObject: {
        items: []
      }
    }
  },
  type: OperationType.data
}, {
  persistent: ['finalResponseObject', 'treeParams', 'treeUrl', 'pieceByPieceLoad'],
  type: OperationType.addPersistentData
}, {
  condition: '{treeParams}.limit',
  conditionOperations: [{
    actionType: {
      delay: 100,
      loop: {
        breakOperations: [{
          condition: '!{pieceByPieceLoad}',
          conditionOperations: [{
            args: ['finalResponseObject'],
            moduleName: 'TreeGrid',
            name: 'loadData'
          }],
          type: OperationType.conditional
        }, {
          name: 'treeGridRequestUnMask',
          type: OperationType.action
        }, {
          persistent: ['finalResponseObject', 'treeParams', 'treeUrl', 'pieceByPieceLoad'],
          type: OperationType.removePersistentData
        }],
        condition: '{responseObject}.items.length === {treeParams}.limit',
        counter: 0
      },
      pos: Position.end
    },
    name: 'treeGridRequest',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'treeGridRequest',
    type: OperationType.action
  }, {
    args: ['finalResponseObject'],
    moduleName: 'TreeGrid',
    name: 'loadData'
  }, {
    name: 'treeGridRequestUnMask',
    type: OperationType.action
  }, {
    persistent: ['finalResponseObject', 'treeParams', 'treeUrl', 'pieceByPieceLoad'],
    type: OperationType.removePersistentData
  }],
  type: OperationType.conditional
}];

export const treeGridRequest: Action = [{
  data: {
    template: {
      bind: {
        url: '{treeUrl}',
        params: '{treeParams}'
      }
    },
    update: {
      params: {
        bind: {
          from: '{counter} * {treeParams}.limit',
          limit: '{treeParams}.limit'
        }
      }
    }
  },
  type: OperationType.request
}, {
  data: {
    update: {
      finalResponseObject: {
        bind: {
          items: '{finalResponseObject}.items.concat({responseObject.items})'
        }
      }
    }
  },
  type: OperationType.data
}, {
  condition: '{pieceByPieceLoad}',
  conditionOperations: [{
    args: ['finalResponseObject'],
    moduleName: 'TreeGrid',
    name: 'loadData'
  }],
  type: OperationType.conditional
}];

export const remoteValidation: Action = [{
  data: {
    template: {
      bind: {
        urlParams: '{urlParams}',
        params: '{params}',
        method: '{method} || "head"',
        url: '{url}',
        headers: '{headers}',
        usePrefix: '{usePrefix}'
      }
    }
  },
  mappingName: 'validatedData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        resourceExists: '{validatedData.resourceExists}'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{remoteValidationModuleId}',
  moduleName: '{remoteValidationModuleName}',
  name: 'setValid',
  args: ['resourceExists']
}];

export const refreshRemoteList: Action = [{
  data: {
    template: {
      bind: {
        params: '{params}',
        method: '{method} || "post"',
        url: '{url}',
        headers: '{headers}',
        usePrefix: '{usePrefix}'
      }
    }
  },
  mappingName: 'refreshData',
  type: OperationType.request
}, {
  evaluate: true,
  args: ['refreshData'],
  moduleId: '{refreshModuleId}',
  moduleName: '{refreshModuleName}',
  name: 'parseData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        remoteData: '{parseData}'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{refreshModuleId}',
  moduleName: '{refreshModuleName}',
  name: 'setData',
  args: ['remoteData']
}];

export const refreshAnyDropListData: Action = [{
  data: {
    template: {
      bind: {
        params: '{scrollRequestParams}',
        method: '{method} || "post"',
        url: '{url}',
        headers: '{headers}',
        usePrefix: '{usePrefix}'
      }
    }
  },
  mappingName: 'dropListData',
  type: OperationType.request
}, {
  evaluate: true,
  args: ['dropListData'],
  moduleId: '{dropDownModuleId}',
  moduleName: '{dropDownModuleName}',
  name: 'parseData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        dropDownData: '{parseData}'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{dropDownModuleId}',
  moduleName: '{dropDownModuleName}',
  name: 'setData',
  args: ['dropDownData']
}];

export const warningAnotherUserChangeTotalCount: Action = [{
  persistent: ['navigationGridModuleName', 'navigationGridModuleId'],
  type: OperationType.addPersistentData
}, {
  items: [{
    operations: [{
      data: {
        template: {
          reloadGridConfig: {
            saveScroll: false,
            bind: {
              navigationGridModuleName: '{navigationGridModuleName}',
              navigationGridModuleId: '{navigationGridModuleId}'
            }
          },
          mask: 'self'
        }
      },
      name: 'reloadGrid',
      type: OperationType.action
    }, {
      persistent: ['navigationGridModuleName', 'navigationGridModuleId'],
      type: OperationType.removePersistentData
    }],
    close: true,
    btnName: 'ok',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      data: {
        template: {
          reloadGridConfig: {
            saveScroll: false,
            bind: {
              navigationGridModuleName: '{navigationGridModuleName}',
              navigationGridModuleId: '{navigationGridModuleId}'
            }
          },
          mask: 'self'
        }
      },
      name: 'reloadGrid',
      type: OperationType.action
    }, {
      persistent: ['navigationGridModuleName', 'navigationGridModuleId'],
      type: OperationType.removePersistentData
    }]
  }],
  warningType: WarningType.warning,
  text: 'Dashboard.restartFollows',
  title: 'Dashboard.titleOps',
  type: OperationType.warning
}];

export const refreshAnyNavigationGridData: Action = [{
  condition: '{scrollRequestParams}.search && {scrollRequestParams}.search.length > 0',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          params: '{scrollRequestParams}',
          method: '{method} || "post"',
          url: '{url}',
          headers: '{headers}',
          usePrefix: '{usePrefix}'
        }
      }
    },
    handleError: true,
    mappingName: 'gridData',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          gridData: '{gridData.data}',
          totalElements: '{gridData.data.totalElements}'
        }
      }
    },
    type: OperationType.data
  }, {
    name: 'parseRequestGridData',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      template: {
        bind: {
          params: '{scrollRequestParams}',
          method: '{method} || "post"',
          url: '{url}',
          headers: '{headers}',
          usePrefix: '{usePrefix}'
        }
      }
    },
    mappingName: 'gridData',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          totalElements: '{gridData.totalElements}'
        }
      }
    },
    type: OperationType.data
  }, {
    moduleName: '{navigationGridModuleName}',
    evaluate: true,
    moduleId: '{navigationGridModuleId}',
    name: 'setIsTotalChanged',
    args: ['totalElements']
  }, {
    name: 'parseRequestGridData',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  condition: '{navigationGridModuleName} === "NavigationTreeGrid"',
  conditionOperations: [{
    data: {
      refreshed: true
    },
    evaluate: true,
    moduleId: '{navigationGridModuleId}',
    moduleName: '{navigationGridModuleName}',
    name: 'onExpandAllChange',
    args: ['refreshed']
  }],
  type: OperationType.conditional
}, {
  name: 'setDashboardTitleTotalItems',
  type: OperationType.action
}];

export const parseRequestGridData: Action = [{
  evaluate: true,
  args: ['gridData'],
  moduleId: '{navigationGridModuleId}',
  moduleName: '{navigationGridModuleName}',
  name: 'parseGridData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        gridData: '{parseGridData}'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    template: {
      bind: {
        forceSkip: '{reloadType} === "soft"'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{navigationGridModuleId}',
  moduleName: '{navigationGridModuleName}',
  name: 'setGridData',
  args: ['gridData', 'forceSkip']
}, {
  persistent: ['reloadType'],
  type: OperationType.removePersistentData
}];

export const reloadAnyNavigationGridData: Action = [/* {
  condition: '{navigationGridModuleName} === "NavigationTreeGrid"',
  conditionOperations: [{
    data: {
      forceExpanded: true
    },
    executeType: 'visible',
    args: ['forceExpanded'],
    name: 'executeExpandAll',
    moduleName: 'DashboardGrid'
  }],
  type: OperationType.conditional
}, */{
    evaluate: true,
    moduleId: '{navigationGridModuleId}',
    moduleName: '{navigationGridModuleName}',
    name: 'assignParams',
    args: ['scrollRequestParams', 'assignedParams']
  }, {
    persistent: ['assignedParams'],
    type: OperationType.removePersistentData
  }, {
    evaluate: true,
    propertiesToEvaluate: ['moduleId', 'moduleName', 'name', 'isPromise'],
    moduleId: '{navigationGridModuleId}',
    moduleName: '{navigationGridModuleName}',
    name: '{isSyncReload} ? "syncResetGridData" : "resetGridData"',
    isPromise: '{isSyncReload}',
    isCallback: false
  }, {
    evaluate: true,
    propertiesToEvaluate: ['moduleId', 'moduleName', 'name', 'isPromise'],
    moduleId: '{navigationGridModuleId}',
    moduleName: '{navigationGridModuleName}',
    name: '{isSyncReload} ? "syncRequestData" : "requestData"',
    args: ['pageNumber', 'skip'],
    isPromise: '{isSyncReload}',
    isCallback: false
  }, {
    evaluate: true,
    moduleId: '{navigationGridModuleId}',
    moduleName: '{navigationGridModuleName}',
    name: 'scrollToLastPosition',
    args: ['scrollPosition']
  }, {
    condition: '{navigationGridModuleName} === "NavigationTreeGrid"',
    conditionOperations: [{
      data: {
        refreshed: true
      },
      evaluate: true,
      moduleId: '{navigationGridModuleId}',
      moduleName: '{navigationGridModuleName}',
      name: 'onExpandAllChange',
      args: ['refreshed']
    }],
    type: OperationType.conditional
  } /* , {
  name: 'filterGridAction',
  type: OperationType.action
}, {
  name: 'refreshAnyNavigationGridData',
  type: OperationType.action
} */];

const treeListRequestParamsOperations: Action = [{
  moduleName: 'SearchBar',
  name: 'getSearchKey',
  mappingName: 'searchKey',
  type: OperationType.addOperationData
}, {
  moduleName: 'SearchBar',
  name: 'getSearchValue',
  mappingName: 'searchValue',
  type: OperationType.addOperationData
}, {
  condition: '{searchValue}.length !== 0',
  conditionOperations: [{
    data: {
      update: {
        treeListRequestParams: {
          bind: {
            '{searchKey}': '{searchValue}'
          }
        }
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}];

export const navigationTreeGridDataList: Action = [{
  condition: '!{subRowIdMapValue} && {shouldUseSearchBar}',
  conditionOperations: treeListRequestParamsOperations,
  type: OperationType.conditional
}, {
  data: {
    template: {
      bind: {
        params: '{urlParams} ? undefined : {treeListRequestParams}',
        method: '{method} || "post"',
        url: '{url}',
        urlParams: '{urlParams}',
        headers: '{headers}'
      }
    }
  },
  mappingName: 'treeGridDataList',
  type: OperationType.request
}, {
  evaluate: true,
  args: ['treeGridDataList', 'treeListOtherParams'],
  moduleId: '{navigationTreeGridModuleId}',
  moduleName: 'NavigationTreeGrid',
  name: 'parseGridExtendedData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        treeGridDataList: '{parseGridExtendedData}'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{navigationTreeGridModuleId}',
  moduleName: 'NavigationTreeGrid',
  name: 'setTreeGridDataList',
  args: ['treeDataItem', 'treeGridDataList']
}];

export const navigationTreeGridDataListMulti: Action = [{
  condition: '!{subRowIdMapValue} && {shouldUseSearchBar}',
  conditionOperations: treeListRequestParamsOperations,
  type: OperationType.conditional
}, {
  data: {
    template: {
      bind: {
        params: '{urlParams} ? undefined : {treeListRequestParams}',
        method: '{method} || "post"',
        url: '{url}',
        urlParams: '{urlParams}',
        headers: '{headers}'
      }
    }
  },
  mappingName: 'treeGridDataList',
  type: OperationType.request
}, {
  evaluate: true,
  args: ['treeGridDataList', 'treeListOtherParams'],
  moduleId: '{navigationTreeGridModuleId}',
  moduleName: 'NavigationTreeGrid',
  name: 'parseGridExtendedData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        treeGridDataList: '{parseGridExtendedData}'
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{navigationTreeGridModuleId}',
  moduleName: 'NavigationTreeGrid',
  name: 'setSubItems',
  args: ['treeGridDataList']
}];

export const reloadPath: Action = [{
  condition: '{path} !== undefined',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          path: '{path}'
        }
      }
    },
    type: OperationType.redirect
  }],
  type: OperationType.conditional
}];

export const initialMenuLoadData: Action = [{
  data: {
    template: {
      bind: {
        params: '{params}',
        method: '{method} || "post"',
        url: '{url}',
        headers: '{headers}',
        usePrefix: '{usePrefix}'
      }
    }
  },
  mappingName: 'initialData',
  type: OperationType.request
}, {
  evaluate: true,
  args: ['initialData'],
  moduleId: '{menuModuleId}',
  moduleName: '{menuModuleName}',
  name: 'parseData',
  mappingName: 'initialParseData',
  type: OperationType.addOperationData
}, {
  evaluate: true,
  moduleId: '{menuModuleId}',
  moduleName: '{menuModuleName}',
  name: 'loadData',
  args: ['initialParseData']
}];

export const setActiveGridModuleId: Action = [{
  moduleName: 'TabPanel',
  name: 'getModuleIdOfActiveGrid',
  mappingName: 'moduleId',
  type: OperationType.addOperationData
}];

export const getRowDataItem: Action = [{ 
  moduleName: 'Dashboard',
  name: 'hasTabPanelConfig',
  mappingName: 'isTabPanelConfigSet',
  type: OperationType.addOperationData
}, {
  condition: '{isTabPanelConfigSet}',
  conditionOperations: [{
    name: 'setActiveGridModuleId',
    type: OperationType.action
  }, {
    evaluate: true,
    moduleId: '{moduleId}',
    moduleName: 'DashboardGrid',
    name: 'getSelectedRowDataItem',
    mappingName: 'dataItem',
    type: OperationType.addOperationData
  }],
  elseOperations: [{
    moduleName: 'DashboardGrid',
    name: 'getSelectedRowDataItem',
    mappingName: 'dataItem',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  condition: '{dataItem} === null',
  conditionOperations: [{
    className: 'sm footer-centered',
    items: [{
      btnConfig: {
        dock: DockType.bottom,
        pos: Position.end
      },
      btnName: 'Close',
      operations: []
    }],
    text: 'noSelectedRow.text',
    title: 'noSelectedRow.title',
    type: OperationType.warning,
    warningType: WarningType.warning
  }, {
    type: OperationType.stopAll
  }],
  elseOperations: [],
  type: OperationType.conditional
}];

export const reloadGridMask: Action = [{
  condition: '{mask}',
  all: [{
    evaluate: true,
    moduleName: '{topLevelComponentName}',
    type: OperationType.maskModule
  }],
  self: [{
    evaluate: true,
    moduleName: '{reloadGridModuleName}',
    moduleId: '{reloadGridModuleId}',
    type: OperationType.maskModule
  }],
  type: OperationType.switch
}];

export const reloadGridUnMask: Action = [{
  condition: '{mask}',
  all: [{
    evaluate: true,
    moduleName: '{topLevelComponentName}',
    type: OperationType.unmaskModule
  }],
  self: [{
    evaluate: true,
    moduleName: '{reloadGridModuleName}',
    moduleId: '{reloadGridModuleId}',
    type: OperationType.unmaskModule
  }],
  type: OperationType.switch
}];

export const reloadGrid: Action = [{
  condition: '{reloadGridConfig}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          params: '{reloadGridConfig}.params',
          url: '{reloadGridConfig}.url',
          method: '{reloadGridConfig}.method',
          saveScroll: '{reloadGridConfig}.saveScroll',
          reloadDisplayedGrid: '{reloadGridConfig}.reloadDisplayedGrid',
          reloadType: '{reloadGridConfig}.reloadType',
          assignedParams: '{reloadGridConfig}.assignedParams',
          navigationGridModuleId: '{reloadGridConfig}.navigationGridModuleId',
          navigationGridModuleName: '{reloadGridConfig}.navigationGridModuleName ?? "DashboardGrid"'
        }
      }
    },
    type: OperationType.data
  }],
  elseOperations: [{
    data: {
      params: {},
      url: '',
      method: '',
      saveScroll: true,
      reloadDisplayedGrid: '{reloadGridConfig}.reloadDisplayedGrid',
      reloadType: RELOAD_TYPE.soft,
      assignedParams: false,
      navigationGridModuleId: undefined,
      navigationGridModuleName: 'DashboardGrid'
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  condition: '{reloadDisplayedGrid} && !{navigationGridModuleId}',
  conditionOperations: [{
    evaluate: true,
    executeType: 'visible',
    displayed: true,
    moduleName: '{navigationGridModuleName}',
    name: 'getModuleId',
    mappingName: 'navigationGridModuleId',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  data: {
    template: {
      bind: {
        reloadGridModuleName: '{navigationGridModuleName}',
        reloadGridModuleId: '{navigationGridModuleId}'
      }
    }
  },
  actionType: {
    persistent: ['reloadGridModuleName', 'reloadGridModuleId', 'isSyncReload', 'saveScroll', 'reloadType', 'assignedParams']
  },
  name: 'reloadGridMask',
  type: OperationType.action
}, {
  evaluate: true,
  isPromise: true,
  isCallback: false,
  moduleId: '{navigationGridModuleId}',
  moduleName: '{navigationGridModuleName}',
  name: 'syncReloadGridData',
  mappingName: 'getReloadGridParams',
  args: ['params', 'url', 'method', 'saveScroll'],
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        url: '{getReloadGridParams}.url',
        method: '{getReloadGridParams}.method',
        scrollRequestParams: '{getReloadGridParams}.scrollRequestParams',
        pageNumber: '{getReloadGridParams}.pageNumber',
        scrollPosition: '{getReloadGridParams}.scrollPosition',
        skip: '{getReloadGridParams}.skip',
        navigationGridModuleId: '{getReloadGridParams}.navigationGridModuleId',
        navigationGridModuleName: '{getReloadGridParams}.navigationGridModuleName'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    isSyncReload: true
  },
  name: 'reloadAnyNavigationGridData',
  type: OperationType.action
}, {
  name: 'reloadGridUnMask',
  type: OperationType.action
}, {
  persistent: ['reloadGridModuleName', 'reloadGridModuleId', 'isSyncReload', 'saveScroll'],
  type: OperationType.removePersistentData
}];
